import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { UppClientEditComponent } from '../components/edit/upp-edit';
import { UppClientThumbComponent } from '../components/thumb/upp-thumb';

@NgModule({
    declarations: [
        UppClientEditComponent,
        UppClientThumbComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        UppBaseModule,
        UppWdgtModule,
        UppDataModule
    ],
    exports: [
        UppClientEditComponent,
        UppClientThumbComponent
    ],
    providers: [],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class FeatureClientModule {}
